import {
  MarketingSection,
  SectionTitle,
} from "@/components/marketing/MarketingSection";
import LineIcon from "@/components/marketing/sections/LineIcon";
import { ICON_TONES } from "@/components/marketing/stems/stemIcons";
import { cn } from "@/lib/utils";

const USES = [
  {
    title: "Remix & collaborate",
    body: "Use isolated vocals and instruments for remixes, new edits, and collaborations.",
    tone: ICON_TONES.blue,
    icon: (
      <>
        <path d="M4 7h3a4 4 0 0 1 4 4v2a4 4 0 0 0 4 4h5" />
        <path d="m17 14 3 3-3 3" />
        <path d="M4 17h3a4 4 0 0 0 3.5-2" />
        <path d="M14 7h6" />
        <path d="m17 4 3 3-3 3" />
      </>
    ),
  },
  {
    title: "Perform live",
    body: "Use your instrumental as a backing track or work with individual stems to build your live arrangement.",
    tone: ICON_TONES.pink,
    icon: (
      <>
        <path d="M9 18V5l10-2v13" />
        <circle cx="6" cy="18" r="3" />
        <circle cx="16" cy="16" r="3" />
      </>
    ),
  },
  {
    title: "Sync licensing",
    body: "Have instrumentals and individual stems ready when a music supervisor or licensing partner requests them.",
    tone: ICON_TONES.teal,
    icon: (
      <>
        <rect x="3" y="5" width="18" height="14" rx="2" />
        <path d="m10 9 5 3-5 3z" />
        <path d="M7 3v2M17 3v2" />
      </>
    ),
  },
  {
    title: "Offer fans more",
    body: "Include instrumental and acapella versions in a Super Single to give fans more ways to experience your music.",
    tone: ICON_TONES.orange,
    icon: (
      <>
        <path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z" />
        <path d="M9 12h6M12 9v6" />
      </>
    ),
  },
];

export default function StemsUses() {
  return (
    <MarketingSection className="bg-[#F6F7FB]">
      <SectionTitle>More ways to use your music.</SectionTitle>
      <div className="mt-[52px] grid grid-cols-2 gap-5 max-[680px]:grid-cols-1 max-[680px]:gap-[14px]">
        {USES.map((use) => (
          <article
            key={use.title}
            className="grid min-h-[210px] grid-cols-[54px_minmax(0,1fr)] items-start gap-[22px] rounded-[24px] border border-[#DDE2EF] bg-white p-[30px] max-[680px]:min-h-0 max-[680px]:grid-cols-[48px_minmax(0,1fr)] max-[680px]:gap-[17px] max-[680px]:p-6"
          >
            <div
              className={cn(
                "grid size-[54px] place-items-center rounded-[15px] max-[680px]:size-12",
                use.tone,
              )}
            >
              <LineIcon className="size-[29px]">{use.icon}</LineIcon>
            </div>
            <div>
              <h3 className="mb-[11px] mt-[2px] font-figtree text-[24px] font-[850] leading-[1.15]">
                {use.title}
              </h3>
              <p className="m-0 font-open-sans text-[17px] leading-[1.6] text-marketing-muted">
                {use.body}
              </p>
            </div>
          </article>
        ))}
      </div>
    </MarketingSection>
  );
}
